import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "upload_box" }
const _hoisted_2 = {
  key: 0,
  class: "hover_box"
}
const _hoisted_3 = { class: "img_box" }
const _hoisted_4 = { class: "img_hover" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  class: "loading_box"
}
const _hoisted_8 = {
  key: 1,
  class: "up_text"
}

import { message, Upload, Modal } from 'ant-design-vue';
import { getToken } from '@/plugins/cookie';
import { ref } from 'vue';
import { PlusOutlined, LoadingOutlined, EyeOutlined, DeleteOutlined } from '@ant-design/icons-vue';
interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: any;
}
interface Props {
  fileList: any;
  name?: any;
  listType?: any;
  showList?: boolean;
  action?: string;
  headers?: any;
  data?: (...args: any[]) => any;
  beforeUpload?: (...args: any[]) => any;
  handleChange: (...args: any[]) => any;
  loading?: boolean;
  imageName?: string;
  clickStop?: (...args: any[]) => any;
  mask?: boolean;
  plus?: boolean;
  uploadText?: boolean;
  disabled: boolean;
  type?: number | string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Ccertificates',
  props: {
    fileList: { default: [] },
    name: { default: 'image' },
    listType: { default: 'picture-card' },
    showList: { type: Boolean, default: false },
    action: {},
    headers: {},
    data: {},
    beforeUpload: {},
    handleChange: {},
    loading: { type: Boolean, default: false },
    imageName: { default: '' },
    clickStop: {},
    mask: { type: Boolean, default: true },
    plus: { type: Boolean, default: true },
    uploadText: { type: Boolean, default: true },
    disabled: { type: Boolean, default: false },
    type: { default: '' }
  },
  setup(__props: any) {

const aUpload = Upload;
const aModal = Modal;
const token = getToken();
const beforeUpload = (file: FileItem) => {
  const isJpgOrPng =
    file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg' || file.type === 'image/gif';
  if (!isJpgOrPng) {
    message.error('上传图片的格式有误!');
  }
  return isJpgOrPng;
};
const props = __props;

const imgChang = (event: any) => {
  const img_one = ref(process.env.VUE_APP_OTHER_LINK+'/business_license.png');
  const img_two = ref(process.env.VUE_APP_OTHER_LINK+'/id_front.png');
  const img_three = ref(process.env.VUE_APP_OTHER_LINK+'/id_back.png');
  var img = event.srcElement;
  img.src = props.type == 0 ? img_one.value : props.type == 1 ? img_two.value : img_three.value;
  img.onerror = null;
  return;
};
const previewVisible = ref<boolean>(false);
const handlePreview = () => {
  previewVisible.value = true;
};
const handleCancel = () => {
  previewVisible.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(aUpload), {
      "v-model:file-list": props.fileList,
      disabled: props.disabled,
      name: props.name,
      "show-upload-list": props.showList,
      action: "/api/v1/common/upload_certificates",
      headers: {
        token: _unref(token),
      },
      data: props.data,
      "before-upload": beforeUpload,
      onChange: props.handleChange,
      class: "ant_upload"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (props.imageName)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _withDirectives(_createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_unref(EyeOutlined), {
                      color: "#fff",
                      onClick: _withModifiers(handlePreview, ["stop"])
                    }),
                    _createVNode(_unref(DeleteOutlined), {
                      id: "disable",
                      onClick: _withModifiers(__props.clickStop, ["stop"])
                    }, null, 8, ["onClick"])
                  ])
                ], 512), [
                  [_vShow, props.mask && !props.disabled]
                ]),
                _renderSlot(_ctx.$slots, "image", {}, () => [
                  (props.imageName)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "upload_img",
                        src: props.imageName,
                        onError: _cache[0] || (_cache[0] = ($event: any) => (imgChang($event)))
                      }, null, 40, _hoisted_5))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(aModal), {
                    visible: previewVisible.value,
                    footer: null,
                    closable: false,
                    onCancel: handleCancel,
                    wrapClassName: "modalbox"
                  }, {
                    default: _withCtx(() => [
                      (props.imageName)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "uploads_img",
                            src: props.imageName,
                            onError: _cache[1] || (_cache[1] = ($event: any) => (imgChang($event)))
                          }, null, 40, _hoisted_6))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["visible"])
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                (props.loading)
                  ? (_openBlock(), _createBlock(_unref(LoadingOutlined), { key: 0 }))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      _withDirectives(_createVNode(_unref(PlusOutlined), null, null, 512), [
                        [_vShow, props.plus]
                      ]),
                      _renderSlot(_ctx.$slots, "uploadImg", {}, () => [
                        _withDirectives(_createElementVNode("div", null, [...(_cache[2] || (_cache[2] = [
                          _createElementVNode("p", null, "上传照片", -1)
                        ]))], 512), [
                          [_vShow, props.uploadText]
                        ])
                      ])
                    ]))
              ]))
        ])
      ]),
      _: 3
    }, 8, ["v-model:file-list", "disabled", "name", "show-upload-list", "headers", "data", "onChange"])
  ]))
}
}

})